import { Tooltip } from "antd";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Builds from "./builds";
import CyberSpace from "./cyber-space";
import Plugins from "./plugins";

const CYBER_TAB_KEY = "/support/cyber";

const Support = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((s) => s.user);

  const items = [
    {
      key: "/support",
      label: "Дистрибутивы",
      children: <Builds />,
    },
    {
      key: "/plugins",
      label: "Решения",
      children: <Plugins />,
    },
  ];

  if (!user?.support) {
    items.push({
      key: "cyber-disabled",
      selectLabel: "Киберинженер",
      label: (
        <Tooltip title="Для доступа необходимо иметь активную подписку">
          <span>Киберинженер</span>
        </Tooltip>
      ),
      disabled: true,
    });
  } else {
    items.push({
      key: CYBER_TAB_KEY,
      label: "Киберинженер",
      children: <CyberSpace />,
    });
  }

  const pathname = location.pathname;
  const activeKey =
    pathname.startsWith("/plugins")
      ? "/plugins"
      : pathname === CYBER_TAB_KEY || pathname.startsWith("/support/")
        ? (user?.support ? CYBER_TAB_KEY : items[0]?.key)
        : items.find((item) => item.key === pathname)?.key || items[0]?.key;

  const onTabChange = (key) => {
    if (key === "cyber-disabled") return;
    navigate(key);
  };

  return (
    <div className="page support-page">
      <MultiPane
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Support;
